import React, { useState } from 'react';
// @ts-ignore
import styles from './EArchiveListItem.module.scss';
import { View } from '../../../../../Enums/View.enum';
import { WorkplacePatientStatus } from '../../../Enums/WorkplacePatientStatus.enum';
import EArchiveListItemListView from './EArchiveListItemListView';
import EArchiveListItemGridView from './EArchiveListItemGridView';
import TreatmentModal from '../../../../../Components/Treatment/TreatmentModal';

export interface EArchiveItem {
	id: string;
	createdAt: string;
	status: WorkplacePatientStatus;
	user: {
		id: string;
		profile: {
			birthDate: string;
			birthNumber: string;
			formattedBirthNumber: string;
			age: string;
			contactEmail: string;
			contactPhoneNumber: string;
			firstName: string;
			lastName: string;
			fullName: string;
			insuranceCompanyTermItem: {
				id: string;
				value: string;
				value2: string;
			};
			address: {
				fullAddress: string;
				street: string;
				guideNumber: string;
				descriptiveNumber: string;
				city: string;
				postCode: string;
			};
		};
		profileImageUrl: string;
		avatarUrl: string;
		csszResult: {
			result: any;
			checkedAt: string;
		};
		vzpResult: {
			result: any;
			checkedAt: string;
		};
		hasMeddi: boolean;
		email: string;
		formattedPhoneNumber: string;
		isChild: boolean;
		parents: {
			profile: {
				fullName: string;
			};
			formattedPhoneNumber: string;
			email: string;
		}[];
		workplaceMember?: {
			dateOfDeath?: boolean;
		}
	};
}

interface Props {
	item: EArchiveItem;
	onRefresh?: () => void;
	view: View;
}

const EArchiveListItem: React.FC<Props> = ({ view, item, onRefresh }) => {
	const [isTreatmentOpen, setTreatmentOpen] = useState(false);

	let component = <></>;

	if (view === View.LIST) {
		component = (
			<EArchiveListItemListView
				item={item}
				onClick={() => setTreatmentOpen(true)}
			/>
		);
	}

	if (view === View.GRID) {
		component = (
			<EArchiveListItemGridView
				item={item}
				onClick={() => setTreatmentOpen(true)}
			/>
		);
	}

	return (
		<>
			{component}
			{isTreatmentOpen && (
				<TreatmentModal
					opened
					patientId={item.user.id}
					onClose={() => setTreatmentOpen(false)}
					onRefresh={onRefresh}
				/>
			)}
		</>
	);
};

export default EArchiveListItem;
